import { FileText, Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TabsContent } from "@/components/ui/tabs";

export const DocumentsTab = ({ project, fileInputRef, handleFileUpload, uploading }) => (
  <TabsContent value="documents" className="animate-fade-in">
    <div className="bg-[#1A1A1A] border border-[#262626] rounded p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-white">Documents</h3>
        <input type="file" ref={fileInputRef} onChange={handleFileUpload} className="hidden" accept=".pdf,.doc,.docx" />
        <Button onClick={() => fileInputRef.current?.click()} disabled={uploading} className="bg-[#FF4500] hover:bg-[#E65100]">
          <Upload className="w-4 h-4 mr-2" /> {uploading ? "Uploading..." : "Upload Document"}
        </Button>
      </div>

      {project.documents?.length > 0 ? (
        <div className="grid grid-cols-2 gap-4">
          {project.documents.map((doc, idx) => (
            <div key={doc.document_id || idx} className="p-4 bg-[#171717] rounded border border-[#262626] hover:border-[#404040] transition-colors flex items-center gap-4">
              <div className="w-12 h-12 rounded bg-[#262626] flex items-center justify-center">
                <FileText className="w-6 h-6 text-[#FF4500]" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-white font-medium truncate">{doc.name}</p>
                <p className="text-xs text-gray-500">{doc.document_type} • {(doc.file_size / 1024).toFixed(1)} KB</p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="upload-zone text-center py-12 cursor-pointer" onClick={() => fileInputRef.current?.click()}>
          <Upload className="w-12 h-12 text-gray-600 mx-auto mb-4" />
          <p className="text-white font-medium mb-2">Upload Custom Contract</p>
          <p className="text-gray-500 text-sm">Drag and drop or click to upload PDF documents</p>
        </div>
      )}
    </div>
  </TabsContent>
);
